import { useMemo } from "react";

import { ACTION_COLUMN_NAME } from "constants/aggrid";

import { useIsMobile } from "./useScreenSize";

const shouldLockPinned = (colDef, isMobile) =>
  isMobile ? true : colDef.lockPinned;

const shouldBePinned = (colDef, isMobile) =>
  isMobile && colDef.headerName !== ACTION_COLUMN_NAME ? false : colDef.pinned;

const shouldBeHidden = (colDef, isMobile) => {
  if (isMobile) {
    if (colDef.context?.showOnMobile) {
      return false;
    }
    if (colDef.context?.hideOnMobile) {
      return true;
    }
    // always want to show the actions column
    return colDef.headerName !== ACTION_COLUMN_NAME ? colDef.hide : false;
  }
  return colDef.hide;
};

const buildChildren = (colDef, isMobile) => {
  if (isMobile && colDef.children) {
    return colDef.children.map(childColDef => {
      return {
        ...childColDef,
        ...((childColDef.context?.hideOnMobile ||
          colDef.context?.hideOnMobile) && {
          hide: true,
        }),
      };
    });
  }

  return colDef.children;
};

const setColumnWidth = (colDef, isMobile) => {
  if (isMobile) {
    return colDef.headerName === ACTION_COLUMN_NAME
      ? colDef.context?.mobileWidth || 60
      : colDef.width;
  }
  return colDef.width;
};

const setColumnFlex = (colDef, isMobile) => {
  if (isMobile && colDef.context?.flexOnMobile) {
    return 1;
  }
  return null;
};

export const useHandleAgGridColumnDefs = columnDefs => {
  const isMobile = useIsMobile();

  const stableHandledColumnDefs = useMemo(() => {
    const updatedColumnDefs = Object.values(columnDefs).map(colDef => ({
      ...colDef,
      lockPinned: shouldLockPinned(colDef, isMobile),
      pinned: shouldBePinned(colDef, isMobile),
      hide: shouldBeHidden(colDef, isMobile),
      children: buildChildren(colDef, isMobile),
      flex: setColumnFlex(colDef, isMobile),
      width: setColumnWidth(colDef, isMobile),
    }));

    return updatedColumnDefs;
  }, [isMobile, columnDefs]);

  return stableHandledColumnDefs;
};
